export default __webpack_public_path__ + "static/equity-35c28394ad29c53b1ee5112c9d3df2b1.png";